import { TournamentTeamStatus } from '@okletsplay/core';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    textTransform: 'capitalize',
  },

  [TournamentTeamStatus.Pending as string]: {
    color: theme.palette.lobby.team.status.pending,
  },

  [TournamentTeamStatus.Standby as string]: {
    color: theme.palette.lobby.team.status.standby,
  },

  [TournamentTeamStatus.Ready as string]: {
    color: theme.palette.lobby.team.status.ready,
  },

  [TournamentTeamStatus.Checkin as string]: {
    color: theme.palette.lobby.team.status.checkin,
  },

  [TournamentTeamStatus.Active as string]: {
    color: theme.palette.lobby.team.status.active,
  },

  [TournamentTeamStatus.Inactive as string]: {
    color: theme.palette.lobby.team.status.inactive,
  },

  [TournamentTeamStatus.Eliminated as string]: {
    color: theme.palette.lobby.team.status.eliminated,
  },

  [TournamentTeamStatus.Disqualified]: {
    color: theme.palette.lobby.team.status.disqualified,
  },
}));
